import i18next from 'i18next';
import getSearchParams from 'src/js/utils/get-search-params';
import store from 'src/js/store';
import setErrorMessage from '../actions/set-error-message';

const loadErrorFromQuery = () => {
  const searchParams = getSearchParams();
  const errorCode = searchParams.get('error_code');

  if (errorCode) {
    searchParams.delete('error_code');

    const errorMessage = i18next.t('Authentication failed');
    const newUrl = `${window.location.pathname}${searchParams.toString() ? `?${searchParams.toString()}` : ''}`;

    window.history.replaceState({}, '', newUrl);

    store.dispatch(setErrorMessage(errorMessage));
  }

  return errorCode;
};

export default loadErrorFromQuery;
